import { render, staticRenderFns } from "./SubjectForm.vue?vue&type=template&id=788befe5&"
import script from "./SubjectForm.vue?vue&type=script&lang=js&"
export * from "./SubjectForm.vue?vue&type=script&lang=js&"
import style0 from "./SubjectForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports